import OfficeLandingHeader from './OfficeLandingHeader';

export { type OfficeLandingHeaderProps } from './OfficeLandingHeader';
export default OfficeLandingHeader;
